import { keyframes } from 'styled-components'

export const animFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(var(--anim-move-y, 10px));
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
